import PageProtected from "../../../../components/Page/PageProtected";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import MouthSectionComposition from "./Composition/MouthSectionComposition";
import MouthSectionTeeth from "./Teeth/MouthSectionTeeth";
import MouthSectionTongue from "./Tongue/MouthSectionTongue";
import MouthSectionBreath from "./Breath/MouthSectionBreath";


import { useTheme } from "@mui/material";

export default function MouthMicrobiomeWelcome() {

    const theme = useTheme();

return (
<>
    


    <PageProtected
    
    headline="MOUTH MICROBIOME - " 
    specify ="ANALYSIS"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C500"
            Section_1={ <MouthSectionComposition /> }

            colorSection_2="grey.C300"
            Section_2={ <MouthSectionTeeth /> }
            
            colorSection_3="grey.C400"
            Section_3= { <MouthSectionTongue /> } 

            colorSection_4="grey.C500"
            Section_4={ <MouthSectionBreath />}

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="greydark.C900"
            Section_1={ <MouthSectionComposition /> }

            colorSection_2="greydark.C700"
            Section_2={ <MouthSectionTeeth /> }
            
            colorSection_3="greydark.C900"
            Section_3= { <MouthSectionTongue /> } 

            colorSection_4="greydark.C700"
            Section_4={ <MouthSectionBreath />}
        />
        )}
    </>
    }
/>

</>
)
}